<template>
    <v-client-table :data="employers" :columns="columns" :options="options">
        <template v-slot:amfCode="{ row }">
            <div>
                <a @click.prevent="showEmployer(row)" class="text-decoration-underline" href="#">{{ row.amfCode }}</a>
            </div>
        </template>
    </v-client-table>
</template>

<script>
export default {
    data(){
        return {
            employers: [],
            columns: ['amfCode', 'name', 'version','active', 'encrypts','sendsDemographics', 'sendsAccounts', 'sendsPayDeposits', 'sendsDependents'],
            options: {
                ...utils.getVueTablesOptions(),
                texts: {
                    filter: null,
                    count: '',
                },
                skin: 'table table-bordered table-condensed table-striped',
                uniqueKey: "employerEdiId",
                headings: {
                    'amfCode': "AMF Code",
                    'name': "Employer Name",
                    'version': "Version",
                    'active': "Active",
                    'encrypts': "Encrypts",
                    'sendsDemographics': "Sends IB",
                    'sendsAccounts': "Sends IC",
                    'sendsPayDeposits': "Sends IH",
                    'sendsDependents': "Sends ID"
                },
                columnsClasses:{                     
                    'sendsDemographics': 'vt-1',
                    'sendsAccounts': 'vt-1',
                    'sendsPayDeposits': 'vt-1',
                    'sendsDependents': 'vt-1',                   
                    'active': 'vt-1',
                    'encrypts': 'vt-1',   
                    'version': 'vt-2'                                  
                },
                cellClasses:{
                    active:[{
                        class: 'fa fa-check d-table-cell text-center',
                        condition: row => row.active
                    }],
                    encrypts:[{
                        class: 'fa fa-check d-table-cell text-center',
                        condition: row => row.encrypts
                    }],
                    sendsDemographics:[{
                        class: 'fa fa-check d-table-cell text-center',
                        condition: row => row.sendsDemographics
                    }],
                    sendsAccounts:[{
                        class: 'fa fa-check d-table-cell text-center',
                        condition: row => row.sendsAccounts
                    }],
                    sendsPayDeposits:[{
                        class: 'fa fa-check d-table-cell text-center',
                        condition: row => row.sendsPayDeposits
                    }],
                    sendsDependents:[{
                        class: 'fa fa-check d-table-cell text-center',
                        condition: row => row.sendsDependents
                    }],
                }
            },
        }        
    },
    async created(){
        this.employers = await romeApi.get('edi/allemployers');
    },
    methods: {
        async showEmployer(row) {              
            await this.$store.dispatch('employerEdi/load', row.employerId);            
            this.$router.push(`/employer/${row.employerId}/edi`);            
        },
    }    
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/edi/EmployerEdiList.vue